export default {
  brand: null,
  brands: [],
};
